// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import "babel-polyfill";
import Vue from "vue";


// Components
import "./components";

// Plugins
import "./plugins";

//setInterval and setTimeout overrider
import hackTimer from "hacktimer"
Vue.use(hackTimer)

import App from "./App";
import router from "@/router";
import api from "@/_api";
import { store } from "./store";
import qrcode from "qrcode";

import BootstrapVue from "bootstrap-vue";

import globals from "./globals";
import globalMethods from "./globalMethods";
import Popper from "popper.js";

import JSZip from "jszip";
import axios from "axios";

//máscaras
import VueTheMask from "vue-the-mask";   
Vue.use(VueTheMask);

import { TheMask } from 'vue-the-mask'
Vue.component(TheMask)
import money from "v-money";
Vue.use(money, {
  precision: 2,
  decimal: ",",
  thousands: ".",
  prefix: "",
  suffix: "",
  masked: false
});

import { VMoney } from "v-money";
Vue.directive("money", VMoney);

//lodash: executar função com delay 
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

// name is optional
Vue.use(VueLodash, { lodash: lodash })

import vSelect from "vue-select";

import "@progress/kendo-ui";
import "@progress/kendo-theme-bootstrap/dist/all.css";
import {
  Grid,
  GridInstaller,
  GridColumn
} from "@progress/kendo-grid-vue-wrapper";
import {
  DataSource,
  HierarchicalDataSource,
  GanttDataSource,
  GanttDependencyDataSource,
  PivotDataSource,
  SchedulerDataSource,
  TreeListDataSource,
  DataSourceInstaller
} from "@progress/kendo-datasource-vue-wrapper";
import {
  Calendar,
  DateinputsInstaller
} from "@progress/kendo-dateinputs-vue-wrapper";

import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";

import {
  Button,
  ButtonGroup,
  ToolBar,
  ToolBarItem,
  ButtonGroupButton,
  ButtonsInstaller
} from "@progress/kendo-buttons-vue-wrapper";
import "@progress/kendo-ui/js/cultures/kendo.culture.pt-BR";
import { Notification, Tooltip, PopupsInstaller } from '@progress/kendo-popups-vue-wrapper';

kendo.culture("pt-BR");

import BlockUI from "vue-blockui";

//upload agent
import VueFileAgent from "vue-file-agent";
import VueFileAgentStyles from "vue-file-agent/dist/vue-file-agent.css";
import { ContainerMixin, ElementMixin } from "vue-slicksort";     

Vue.use(VueFileAgent);
Vue.use(VueFileAgentStyles);
Vue.use(ContainerMixin);
Vue.use(ElementMixin);

import JsonExcel from 'vue-json-excel'
 
Vue.component('downloadExcel', JsonExcel)

Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
import { Validator, ValidatorInstaller } from '@progress/kendo-validator-vue-wrapper';

Vue.use(ValidatorInstaller);



// Kendo
Vue.use(GridInstaller);
Vue.use(DataSourceInstaller);
Vue.use(DateinputsInstaller);
Vue.use(ButtonsInstaller);

Vue.use(Datepicker);
Vue.use(PopupsInstaller);
Vue.component("multiselect", Multiselect);
Vue.component("datepicker", Datepicker);

Vue.use(BlockUI);

Vue.prototype.$api = api;
Vue.prototype.$store = store;
Vue.prototype.$qrcode = qrcode;

// Global RTL flag
Vue.mixin({
  data: globals,
  methods: {
    ...globalMethods
  }
});



window.JSZip = JSZip;

new Vue({
  router,
  axios,
  components: {
    Grid,
    DataSource,
    HierarchicalDataSource,
    GanttDataSource,
    GanttDependencyDataSource,
    PivotDataSource,
    SchedulerDataSource,
    TreeListDataSource,
    DataSourceInstaller,
    Calendar,
    ContainerMixin,
    ElementMixin
  },
  render: h => h(App),
  created() {
    const userString = localStorage.getItem("user");
    if (userString) {
      const userData = JSON.parse(userString);
      this.$store.commit("SET_USER_DATA", userData);
    }
  }
}).$mount("#app");
